$(function () {

  // 1桁のときに 0 を付ける関数
  function zeroPad(num) {
    return num < 10 ? '0' + num : num;
  }

  // ----------------------------
  // campaign slider
  // ----------------------------
  var $campaign = $('.campaign .slide01');

  $campaign
    .on('init', function (event, slick) {
      $(this).append(
        '<div class="slick-num">' +
          '<span class="now-count"></span>／<span class="all-count"></span>' +
        '</div>'
      );

      // このスライダー内のカウントだけ更新（他スライダーと干渉させない）
      $(this).find('.now-count').text(zeroPad(slick.currentSlide + 1));
      $(this).find('.all-count').text(zeroPad(slick.slideCount));
    })
    .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      $(this).find('.now-count').text(zeroPad(nextSlide + 1));
    })
    .slick({
      speed: 1000,
      arrows: true,
      dots: false,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false
    });

  // ----------------------------
  // magnificPopup + popup slick
  // ----------------------------
  $('.popup-modal').magnificPopup({
    type: 'inline',
    preloader: false,

    // 背景クリックで閉じる（明示）
    closeOnBgClick: true,
    closeOnContentClick: false,

    // どこかで modal:true が混ざると閉じなくなるので明示
    modal: false,

    callbacks: {
      open: function () {
        // 今開いている inline コンテンツ内の「直下の ul」だけ（ネスト ul を避ける）
        var $slider = this.content.find('> ul');
        if (!$slider.length) return;

        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick({
            speed: 1000,
            arrows: true,
            dots: false,
            variableWidth: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false,
            initialSlide: 0,
            infinite: true
          });
        }

        // 重要：モーダル表示後に再計算＆先頭へ
        setTimeout(function () {
          $slider.slick('setPosition');
          $slider.slick('slickGoTo', 0, true);
        }, 0);
      },
      resize: function () {
        var $slider = this.content.find('> ul');
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('setPosition');
        }
      }
    }
  });

  // 背景（モーダル外）クリックで確実に閉じるフォールバック
  $(document).on('click', '.mfp-container', function (e) {
    if ($(e.target).closest('.mfp-content').length === 0) {
      $.magnificPopup.close();
    }
  });

  // 閉じるリンクの設定
  $(document).on('click', '.popup-modal-dismiss', function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });

});
